const _signatures = {
  JVBERi0: "application/pdf",
  R0lGODdh: "image/gif",
  R0lGODlh: "image/gif",
  iVBORw0KGgo: "image/png",
  "/9j/": "image/jpg"
};

function _b64toBlob(b64Data, contentType, sliceSize = 512) {
  contentType = contentType || '';

  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
}

function _detectMimeType(b64) {
  for (const s in _signatures) {
    if (b64.indexOf(s) === 0) {
      return _signatures[s];
    }
  }
}

export const stringB64toFile = (strB64, nameFile) => {
  const block = strB64.split(";");
  // Get the content type of the image
  const contentType = block[0].split(":")[1];// In this case "image/gif"
  // get the real base64 content of the file
  const realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."

  // Convert it to a blob to upload
  const blob = _b64toBlob(realData, contentType);
  const mimeType = _detectMimeType(realData);
  const extension = strB64.substring(strB64.indexOf('/') + 1, strB64.indexOf(';base64'));

  // Create a FormData and append the file with "image" as parameter name
  return new File([blob], `${nameFile}.${extension}`, { type: mimeType })
}

// function getBase64(file) {
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.readAsDataURL(file);
//     reader.onload = () => resolve(reader.result);
//     reader.onerror = error => reject(error);
//   });
// }

export const compressImage = (imageFile, quality) => {
  return new Promise((resolve, reject) => {
    const $canvas = document.createElement("canvas");
    const image = new Image();
    image.onload = () => {
      $canvas.width = image.width;
      $canvas.height = image.height;
      $canvas.getContext("2d")?.drawImage(image, 0, 0);
      $canvas.toBlob(
        (blob) => {
          if (blob === null) {
            return reject(blob);
          } else {
            resolve(new File([blob], `${imageFile.name}`, { type: imageFile.type }))
          }
        },
        imageFile.type,
        quality / 100
      );
    };
    image.src = URL.createObjectURL(imageFile);

  });
};


export const resizeImage = (imageFile, maxSize = 1000)=> {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement("canvas") ;
    const ctx = canvas.getContext("2d");
    const image = new Image();
    image.onload = () => {
      const max = Math.max(image.width, image.height);
      const score = max > maxSize ? max / maxSize : 1;
      // $canvas.width = image.width;
      // $canvas.height = image.height;

      canvas.height = canvas.width * (image.height / image.width);

      // step 1 - resize to 50%
      const oc = document.createElement('canvas');
      const octx = oc.getContext('2d');

      oc.width = image.width / score;
      oc.height = image.height / score;
      octx?.drawImage(image, 0, 0, oc.width, oc.height);

      // step 2
      octx?.drawImage(oc, 0, 0, oc.width, oc.height);

      // step 3, resize to final size
      ctx?.drawImage(oc, 0, 0, oc.width, oc.height,
        0, 0, canvas.width, canvas.height);

      // $canvas.getContext("2d")?.drawImage(image, 0, 0, image.width * score, image.height * score);
      oc.toBlob(
        (blob) => {
          if (blob === null) {
            return reject(blob);
          } else {
            resolve(new File([blob], `${imageFile.name}`, { type: imageFile.type }))
          }
        },
        imageFile.type,
      );

    };
    image.src = URL.createObjectURL(imageFile);

  });
};